/** This mixin provides methods to be called from different places on the app
 * related to downloading a file
 * @mixin */

export default {
  methods: {
    /**
     * @param {object} response - the response from the api call to download a file
     * @param {string} defaultFileName - a default file name in case it cannot be
     * determined from the response
     */
    getFileNameFromResponseHeader(response, defaultFileName) {
      const filenameRegex = /filename=(.*);/;
      const matches = filenameRegex.exec(response.headers['content-disposition']);
      let filename = matches ? matches[1] : defaultFileName;
      filename = filename.replace(/"/g, '');
      return filename;
    },
  },
};
